<div *ngIf="message" class="toast" [ngClass]="severity" @fade>
  {{message}}
  <i class="material-icons close-icon" (click)="onClose()">close</i>
</div>
